import React from "react";
import SearchIcon from '@mui/icons-material/SearchTwoTone';
import { InputGroup, Button, FormControl,  Col } from "react-bootstrap";

import DataGridRefund from './DataTable';

export const Refund = () => {

    return (
        <div>
            <div className={`card card-custom`}>
                {/* Start Box Header */}
                <div className="card-header border-0 pt-5">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder text-dark">
                            مدیریت استرداد وجه
                        </span>
                        <span className="text-muted mt-3 font-weight-bold font-size-sm">
                            لیست درخواست ها
                        </span>
                    </h3>
                    <div className="card-toolbar">
                        {/* <Button variant="success" onClick={handleShow}>
                            <AddCircle className='mr-1' />
                             ایجاد اطلاعات جدید
                    </Button> */}
                    </div>
                </div>

                {/*Start body */}
                <div className="card-body pt-3 pb-0">

                    {/* search box */}
                    <div className='border-top pt-3'>
                        <InputGroup className="mb-3">
                            <FormControl aria-describedby="basic-addon1" placeholder='جستجو ...' />
                         
                                <Button variant="secondary"><SearchIcon /></Button>
                          
                        </InputGroup>
                    </div>

                    {/* table */}
                    <Col xs='12' className='tb-reponsive px-0'>
                        <DataGridRefund />
                    </Col>

                </div>
            </div>
        </div>
    );
}
